// import {useEffect, useState} from 'react'
// import SettingsService from '../../app/modules/settings/core/_requests'
// import {PROMOTION_TYPES} from '../../app/modules/settings/core/_const'

interface PromoEligibilityReturn {
  getMarketPromoStatus: (market: string) => {isEligible: boolean; isApplied: boolean}
  marketPromoStatuses: Record<string, {is_promo_eligible: boolean; is_promo_applied: boolean}>
}

// Temporarily disabled due to fraud — restore original implementation to re-enable
const usePromoEligibility = (): PromoEligibilityReturn => {
  return {
    getMarketPromoStatus: () => ({isEligible: false, isApplied: false}),
    marketPromoStatuses: {},
  }
  /*
  const [marketPromoStatuses, setMarketPromoStatuses] = useState<
    Record<string, {is_promo_eligible: boolean; is_promo_applied: boolean}>
  >({})

  useEffect(() => {
    const checkMarketPromoEligibility = async () => {
      try {
        const response = await SettingsService.checkPromoEligibility(PROMOTION_TYPES.MARKET_PROMO)
        if (response && response[PROMOTION_TYPES.MARKET_PROMO]) {
          const marketStatuses = response[PROMOTION_TYPES.MARKET_PROMO]
          setMarketPromoStatuses(marketStatuses)
        }
      } catch (error) {
        console.error('Error checking promo eligibility:', error)
        setMarketPromoStatuses({})
      }
    }

    checkMarketPromoEligibility()
  }, [])

  const getMarketPromoStatus = (market: string) => {
    const status = marketPromoStatuses[market]
    return {
      isEligible: status?.is_promo_eligible || false,
      isApplied: status?.is_promo_applied || false,
    }
  }

  return {
    getMarketPromoStatus,
    marketPromoStatuses,
  }
  */
}

export {usePromoEligibility}
